import * as t from "react";
import r from "../lib/IconBase.es.js";
import m from "../defs/ChatText.es.js";
const e = t.forwardRef((o, a) => /* @__PURE__ */ t.createElement(r, { ref: a, ...o, weights: m }));
e.displayName = "ChatTextIcon";
const n = e;
export {
  n as ChatText,
  e as ChatTextIcon
};
